<template>
    <div>
        <v-dialog :value="value" :width="850" @input="handlePopup">
            <v-card class="pa-6 text-left" min-height="">
                <v-row class="mb-4">
                    <v-col class="py-0">
                        <h4 class="q-display-1 pa-5 white--text text-center q_leads_1">Transfer Tenant
                        </h4>
                    </v-col>
                    <v-col cols="12" class="py-0">
                        <v-progress-linear v-if="loading || saving" indeterminate />
                    </v-col>
                </v-row>
                <v-row class="pb-4" justify="space-around" align="center">
                    <strong>Current Agency:</strong>
                    <div>{{ agent.AgentName }}</div>
                </v-row>
                <div class="my-6 text-center">Note: Transferring this agency will move {{ count }} agents to the target tenant.</div>
                <v-row justify="space-around" align="center">
                    <v-col cols="4">
                        <strong>Select Target Tenant:</strong>
                    </v-col>
                    <v-col cols="4">
                        <v-select
                            v-model="selectedTenantId"
                            :items="filteredTenants"
                            item-text="Tenant"
                            item-value="ID"
                            label="Select Target Tenant"
                        />
                    </v-col>
                </v-row>
                <div v-if="selectedTenant && initiateTransferDisabled" class="text-center red--text">
                    <strong>Top Agent Mismatch:</strong> Please ensure that the top agent for the new tenant is the same as the agency intended for transfer.
                </div>
                <v-row justify="center">
                    <v-btn :disabled="saving || initiateTransferDisabled" @click="initiateTransfer()">Initiate Transfer</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import QuilityAPI from '@/store/API/QuilityAPI.js'

export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        agent: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        selectedTenantId: null,
        loading: false,
        saving: false,
        count: 0,
    }),
    computed: {
        selectedTenant() {
            return this.selectedTenantId
                ? this.filteredTenants.find(({ ID }) => ID === this.selectedTenantId)
                : null
        },
        initiateTransferDisabled() {
            console.log(this.agent.AgentCode, this.selectedTenant);
            return !this.selectedTenant || this.agent.AgentCode !== this.selectedTenant?.TopLevelAgentCode
        },
        filteredTenants() {
            return this.all_enabled_tenants.filter(({ TopLevelAgentID, ID }) => TopLevelAgentID && TopLevelAgentID > 0 && ID !== this.agent?.TenantID)
        },
    },
    watch: {
        agent: {
            handler() {
                this.getRecruitingCount()
            },
            immediate: true,
        },
    },
    methods: {
        handlePopup(value) {
            this.$emit('input', value)
        },
        async initiateTransfer() {
            this.saving = true
            QuilityAPI.transferTenant(this.agent?.TenantID, this.selectedTenantId)
                .then((response) => {
                        this.$emit('show-result', {
                            success: !!response.Error,
                            error: response.Error || '',
                        })
                        this.saving = false
                })
                .catch((error) => {
                    this.$emit('show-result', {
                        error,
                        success: false,
                    })
                    this.saving = false
                });
        },
        async getRecruitingCount() {
            this.loading = true
            const result = await QuilityAPI.getAgentDownlineDirectory(this.agent.AgentCode, {}, this.user.Agent.IsAgencyOwner)
            this.count = result.meta.total
            this.loading = false
        },
    },
}
</script>
